import { render, staticRenderFns } from "./buindingRightBottom2.vue?vue&type=template&id=46b7a655&"
import script from "./buindingRightBottom2.vue?vue&type=script&lang=js&"
export * from "./buindingRightBottom2.vue?vue&type=script&lang=js&"
import style0 from "./buindingRightBottom2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports